import { useCallback } from 'react';
import {
  useCompanyProfileConfirmAssetsMutation,
  type CompanyProfileConfirmAssetsInput,
  type CompanyProfileAssetType,
} from '../graphql';
import { useFApolloPostRequest } from './use-fapollo-post-request';

type Asset = {
  file: File;
  type: CompanyProfileAssetType;
  unsplashId?: string;
};

export const useFApolloAssetsUpload = () => {
  const fApolloPostRequest = useFApolloPostRequest();
  const [confirmAssetsMutation] = useCompanyProfileConfirmAssetsMutation();

  return useCallback(
    async (assets: Asset[]) => {
      const assetsData = await Promise.all(assets.map(({ file }) => fApolloPostRequest(file)));
      const input = assetsData.map<CompanyProfileConfirmAssetsInput>(
        ({ data: { filename } }, index) => ({
          fileId: filename,
          assetType: assets[index].type,
          unsplashId: assets[index].unsplashId,
        }),
      );

      return confirmAssetsMutation({
        variables: {
          input,
        },
      });
    },
    [confirmAssetsMutation, fApolloPostRequest],
  );
};
